import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Avatar = ({ src, alt, name, size = 'md', shape = 'circle', fallback, className = '', style = {}, }) => {
    const sizeMap = {
        xs: 24,
        sm: 32,
        md: 40,
        lg: 48,
        xl: 64,
        '2xl': 80,
    };
    const avatarSize = sizeMap[size];
    const baseStyle = Object.assign({ width: avatarSize, height: avatarSize, borderRadius: shape === 'circle' ? '50%' : '12px', backgroundColor: '#404040', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0 }, style);
    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    };
    const fallbackStyle = {
        fontSize: avatarSize * 0.4,
        fontWeight: 600,
        color: '#C8C8C8',
        textTransform: 'uppercase',
    };
    const getInitials = (nameg) => {
        return nameg
            .split(' ')
            .map((word) => word.charAt(0))
            .join('')
            .slice(0, 2);
    };
    const renderFallback = () => {
        if (fallback) {
            return fallback;
        }
        if (name) {
            return _jsx("span", Object.assign({ style: fallbackStyle }, { children: getInitials(name) }));
        }
        return (_jsx("svg", Object.assign({ width: avatarSize * 0.5, height: avatarSize * 0.5, viewBox: "0 0 24 24", fill: "none", style: { color: '#C8C8C8' } }, { children: _jsx("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z", fill: "currentColor" }) })));
    };
    return (_jsxs("div", Object.assign({ className: className, style: baseStyle }, { children: [src ? (_jsx("img", { src: src, alt: alt || name || 'Avatar', style: imageStyle, onError: (e) => {
                    // Hide image on error and show fallback
                    e.currentTarget.style.display = 'none';
                } })) : null, !src && renderFallback()] })));
};
